// extracted by mini-css-extract-plugin
export default {"wrapper":"BackButton_wrapper__+KM0L","button":"BackButton_button__n9TwW"};